import { ref } from 'vue'
import { defineStore } from 'pinia'
import { piniaPluginPersistedstate } from '#imports'

interface IEcp {
  partner: { partnerId: string } | null
  patient: {
    firstName: string
    lastName: string
  }
  shippingAddress: string | null
}

export const useEcpStore = defineStore(
  'ecpState',
  () => {
    const state = ref<IEcp>({
      partner: null,
      patient: {
        firstName: '',
        lastName: '',
      },
      shippingAddress: null,
    })
    const updateEcpState = (value: IEcp) => {
      state.value = value
    }

    const clearEcpState = () => {
      state.value = {
        partner: null,
        patient: {
          firstName: '',
          lastName: '',
        },
        shippingAddress: null,
      }
    }

    return {
      state,
      updateEcpState,
      clearEcpState,
    }
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
)
